import React, { Component } from 'react';
import Modal from 'react-modal'

const customStyles = {
  content: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0)'
  },
  overlay: {
    zIndex: 10000,
    backgroundColor: 'rgba(0, 0, 0, 0)'
  }
};
export default (props) => {
  return (
    <Modal
      isOpen={props.isOpen}
      style={customStyles}
    >
      {props.children}
    </Modal>
  )
}